import {
  faFacebook,
  faInstagram,
  faTelegram,
  faWhatsapp,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { faCopy, faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useLanguage } from "../../contexts/LanguageContext";
import useToast from "../../hooks/useToast";

const DashboardQR = ({ event, copyShareUrl, handleQRDownload }) => {
  const { t } = useLanguage();
  const { showSuccess } = useToast();

  const shareText = `Check out "${event.name}" - Share your photos from this event!`;
  const shareUrl = event.shareUrl;

  const handleSocialShare = async (platform) => {
    const encodedText = encodeURIComponent(shareText);
    const encodedUrl = encodeURIComponent(shareUrl);

    let url = "";

    switch (platform) {
      case "whatsapp":
        url = `https://wa.me/?text=${encodedText}%20${encodedUrl}`;
        break;
      case "facebook":
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedText}`;
        break;
      case "Xtwitter":
        url = `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`;
        break;
      case "telegram":
        url = `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`;
        break;
      case "instagram":
        // Instagram doesn't have direct URL sharing, copy to clipboard instead
        try {
          if (navigator?.clipboard && navigator?.clipboard?.writeText) {
            await navigator.clipboard.writeText(`${shareText} ${shareUrl}`);
            showSuccess("Link copied to clipboard! You can now paste it in Instagram.");
          } else {
            // Fallback for older browsers or mobile
            const textArea = document.createElement('textarea');
            textArea.value = `${shareText} ${shareUrl}`;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
              document.execCommand('copy');
              showSuccess("Link copied to clipboard! You can now paste it in Instagram.");
            } catch (err) {
              showSuccess("Please manually copy this link: " + shareUrl);
            }
            document.body.removeChild(textArea);
          }
        } catch (error) {
          showSuccess("Please manually copy this link: " + shareUrl);
        }
        return;
      default:
        return;
    }

    window.open(url, "_blank", "width=600,height=400");
  };

  return (
    <div className="sharing-section">
      <div className="qr-section">
        <h3 className="share-event-title">{t("dashboard.qrCode.title")}</h3>
        <p>{t("dashboard.qrCode.description")}</p>
        <div className="qr-container">
          <img src={event.qrCode} alt="QR Code" className="qr-code" />
          <div className="share-info">
            <div className="share-url">
              <input
                type="text"
                value={event.shareUrl}
                readOnly
                className="share-url-input"
              />
              <div className="share-buttons-row">
                <button
                  className="btn btn-primary btn-outline copy-btn"
                  onClick={() => copyShareUrl(event)}
                >
                  <FontAwesomeIcon icon={faCopy} />
                  {t("dashboard.qrCode.copyLink")}
                </button>
                <button
                  className="btn btn-primary btn-sm qr-download-btn"
                  onClick={() => handleQRDownload(event.qrCode, event.name)}
                >
                  <FontAwesomeIcon icon={faDownload} />
                  {t("dashboard.qrCode.downloadCode")}
                </button>
              </div>

              {/* Social Share Buttons */}
              <div className="social-share-section">
                <h4>{t("dashboard.qrCode.shareOn")}</h4>
                <div className="social-share-buttons">
                  <button
                    className="social-btn whatsapp"
                    onClick={() => handleSocialShare("whatsapp")}
                    title="Share on WhatsApp"
                  >
                    <FontAwesomeIcon icon={faWhatsapp} />
                  </button>
                  <button
                    className="social-btn facebook"
                    onClick={() => handleSocialShare("facebook")}
                    title="Share on Facebook"
                  >
                    <FontAwesomeIcon icon={faFacebook} />
                  </button>
                  <button
                    className="social-btn twitter"
                    onClick={() => handleSocialShare("Xtwitter")}
                    title="Share on X"
                  >
                    <FontAwesomeIcon icon={faXTwitter} />
                  </button>
                  <button
                    className="social-btn telegram"
                    onClick={() => handleSocialShare("telegram")}
                    title="Share on Telegram"
                  >
                    <FontAwesomeIcon icon={faTelegram} />
                  </button>
                  <button
                    className="social-btn instagram"
                    onClick={() => handleSocialShare("instagram")}
                    title="Copy for Instagram"
                  >
                    <FontAwesomeIcon icon={faInstagram} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardQR;
